import makeSlice from '@web/slices/subscribe/sliceMaker'

const slice = makeSlice()

export default slice.reducer
